import React, {useState} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import strings from '../../../strings';
import Button from "../../shared/Button";

export default function CancelSubscriptionDialog({
  open,
  onClose,
  onCancelSubscription,
  planName,
  creditsAvailable,
    loading
}) {

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth disableEscapeKeyDown={true}>
      <DialogTitle>{strings.BILLING.CANCEL_SUBSCRIPTION_TITLE || 'Cancel Subscription'}</DialogTitle>
      <Divider />
      <DialogContent>
        <Typography variant="subtitle1" gutterBottom>
          {strings.BILLING.CANCEL_SUBSCRIPTION_CONFIRMATION?.replace('{planName}', planName) || `Are you sure you want to cancel your ${planName} subscription?`}
        </Typography>
        <Box mb={2}>
          <Typography variant="body2" gutterBottom>{strings.BILLING.CANCEL_SUBSCRIPTION_WHAT_HAPPENS || 'What happens when you cancel:'}</Typography>
          <ul style={{marginTop: 0, marginBottom: 8, paddingLeft: 20}}>
            <li>{strings.BILLING.CANCEL_SUBSCRIPTION_REMAIN_ACTIVE}</li>
            <li>{strings.BILLING.CANCEL_SUBSCRIPTION_SWITCH}</li>
            <li>{(strings.BILLING.CANCEL_SUBSCRIPTION_KEEP_CREDITS || '').replace('{creditsAvailable}', creditsAvailable)}</li>
            <li>{strings.BILLING.CANCEL_SUBSCRIPTION_CONTINUE_PURCHASE}</li>
            <li>{strings.BILLING.CANCEL_SUBSCRIPTION_CREDITS_NEVER_EXPIRE}</li>
            <li>{strings.BILLING.CANCEL_SUBSCRIPTION_UPGRADE_ANYTIME}</li>
          </ul>
        </Box>
        <Box mb={2}>
          <Typography variant="body2" gutterBottom>{strings.BILLING.CANCEL_SUBSCRIPTION_REMAINING_CREDITS}</Typography>
          <Typography variant="body2">{(strings.BILLING.CANCEL_SUBSCRIPTION_CURRENT_BALANCE || 'Current balance: {creditsAvailable} credits').replace('{creditsAvailable}', creditsAvailable)}</Typography>
          <Typography variant="body2" color="textSecondary">{strings.BILLING.CANCEL_SUBSCRIPTION_CREDITS_REMAIN_AFTER}</Typography>
        </Box>
        <Box mb={2}>
          <Typography variant="body2" gutterBottom>{strings.BILLING.CANCEL_SUBSCRIPTION_AUTOREPLENISH}</Typography>
          <Typography variant="body2">{strings.BILLING.CANCEL_SUBSCRIPTION_AUTOREPLENISH_DISABLED}</Typography>
          <Typography variant="body2" color="textSecondary">{strings.BILLING.CANCEL_SUBSCRIPTION_AUTOREPLENISH_REENABLE}</Typography>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions style={{ padding: 16 }}>
        <Button onClick={onClose} color="primary" variant="text" disabled={loading}>
          {strings.BILLING.CANCEL_SUBSCRIPTION_KEEP}
        </Button>
        <Button onClick={()=>{
          onCancelSubscription()
        }} color="secondary" variant="contained" loading={loading} disabled={loading}>
          {strings.BILLING.CANCEL_SUBSCRIPTION_ACTION}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
